import { render } from "./_Cadastro.vue?vue&type=template&id=824cfe74&scoped=true"
import script from "./_Cadastro.vue?vue&type=script&lang=ts"
export * from "./_Cadastro.vue?vue&type=script&lang=ts"

import "./_Cadastro.vue?vue&type=style&index=0&id=824cfe74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-824cfe74"

export default script